import { doc, getDoc } from 'firebase/firestore';
import { sortChatsByRecentlyActive } from '../utils/timestamps';

/**
 * Повертає callback для useFirebaseMessaging, який оновлює локальний список чатів
 */
export const createHandleMessageReceived = ({ db, highlight, setChats }) => {
  return async (messageData) => {
    console.log('Processing incoming message:', messageData);

    const { chatId } = messageData || {};
    if (!chatId) return;

    try {
      const chatRef = doc(db, 'chats', chatId);
      const chatSnap = await getDoc(chatRef);

      if (chatSnap.exists()) {
        const chatData = chatSnap.data();

        setChats((prevChats) => {
          const updated = prevChats.map((chat) =>
            chat.id === chatId
              ? {
                  ...chat,
                  lastMessage: chatData.lastMessage,
                  lastMessageTimestamp: chatData.lastMessageTimestamp,
                }
              : chat
          );

          return sortChatsByRecentlyActive(updated);
        });

        highlight(chatId);
      }
    } catch (error) {
      console.error('Error updating chat after message received:', error);
    }
  };
};
